/**
 * This button is ideal for small buttons. Used for ticket button on small game widget
 */
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { StyleSheet, css } from 'aphrodite';
import './css/Button3.css';

const Button3 = (props) => {
    const { title, fontSize, fontFamily, height, width, backgroundColor, fontColor, borderRadius, onClick } = props;

    const styles = StyleSheet.create({
        disabled: {
            height,
            width,
            fontSize,
            fontFamily,
            borderRadius,
        },
        button: {
            backgroundColor,
            height,
            width,
            fontSize,
            fontFamily,
            color: fontColor,
            borderRadius,
        },
    });

    return (
        <button
            className={`button-3 ${css(styles.button)}`}
            onClick={onClick}
            type="button"
            style={{ textTransform: 'uppercase' }}
        >
            {title}
        </button>
    );
};

Button3.propTypes = {
    title: PropTypes.string.isRequired,
    fontSize: PropTypes.string,
    fontFamily: PropTypes.string,
    height: PropTypes.string,
    width: PropTypes.string,
    backgroundColor: PropTypes.string,
    fontColor: PropTypes.string,
    borderRadius: PropTypes.string,
    onClick: PropTypes.func,
};

Button3.defaultProps = {
    fontSize: '1rem',
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    height: 'auto',
    width: '150px',
    backgroundColor: '#171d28',
    fontColor: 'black',
    borderRadius: '5px',
    onClick: () => {},
};

export default memo(Button3);
